import React from 'react';
import { NumberInput } from '@mantine/core';

import { Filter } from '../FiltersMenu';
import { useFiltersContextHelper } from '../useFiltersContextHelper';
import OperationSelect from '../OperationSelect';
import AddFilterBtn from '../AddFilterBtn';
import FilterFooter from '../FilterFooter';
import { findFiltersByPath } from '../../../../context/helpers';
import {useIdeaFilters} from "../../../../hooks/useIdeaFilters";

interface NumberFilterProps {
  filters?: Filter;
  MenuType: "idea" | "evidence";
  // activeFilters: ActiveFilter[];
  // setActiveFilters: (obj: any) => void;

}

const NumberFilter: React.FC<NumberFilterProps> = ({
  MenuType
}) => {
  const {
    setActiveFilters,
    operator,
    setOperator,
    numberValue,
    setNumberValue,
    selectedParentFilter,
    childFiltersValue,
  } = useFiltersContextHelper();
  const { ideasFiltersConfig } = useIdeaFilters();


  const _selectedParentFilter: string[] = selectedParentFilter?.split('.') || [''];

  const selectedFilter = (_selectedParentFilter && _selectedParentFilter.length === 2)
  //@ts-ignore
    ? ideasFiltersConfig[MenuType][_selectedParentFilter[0]]?.childFilters[_selectedParentFilter[1]]
    : ideasFiltersConfig[MenuType][_selectedParentFilter[0]]

  const selectedHasOperations = selectedFilter?.operations?.length > 0 || false;
  const currentNumberValue = numberValue?.[selectedParentFilter];
  const hasNumberValue =
    currentNumberValue !== undefined &&
    currentNumberValue !== null &&
    currentNumberValue !== '';
  const currentOperator = operator?.[selectedParentFilter];
  const isApplyDisabled =
    !hasNumberValue || (selectedHasOperations && !currentOperator);

  return (
    selectedParentFilter && <>
      {selectedHasOperations && (
        <OperationSelect
          operations={selectedFilter.operations}
          value={currentOperator ?? null}
          onChange={(value) => {
            setOperator((prev: any) => ({
              ...prev,
              [selectedParentFilter]: value,
            }));
          }}
        />
      )}
      <NumberInput
        py="sm"
        radius="md"
        px={5}
        value={numberValue?.[selectedParentFilter]}
        placeholder={`Enter value`}
        onChange={(val: number) =>
          setNumberValue((prev) => ({
            ...prev,
            [selectedParentFilter]: val,
          }))
        }
        parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
        formatter={(value: any) =>
          selectedFilter?.formatter
            ? !Number.isNaN(parseFloat(value))
              ? `${selectedFilter?.formatter} ${value}`.replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )
              : `${selectedFilter.formatter} `
            : value
        }
      />

      <FilterFooter
        ApplyButton={
          <AddFilterBtn
            BtnText={`Apply`}
            selectedParentFilter={selectedParentFilter}
            childFiltersValue={childFiltersValue}
            disabled={isApplyDisabled}
            onClick={() => {
              const parentFilterObj = findFiltersByPath(ideasFiltersConfig, `${MenuType}.${selectedParentFilter}`);
              const resolvedOperator = currentOperator ?? 'equal';

              setActiveFilters((prevFilters: any) => [
                {
                  ...parentFilterObj,
                  type: parentFilterObj?.type,
                  parent: selectedParentFilter,
                  operator: resolvedOperator,
                  selected: [currentNumberValue],
                  query: currentNumberValue ?? 0,
                },
                ...prevFilters.filter(
                  (prevF: any) => prevF.parent !== selectedParentFilter
                ),
              ]);
              // resetFilters();
            }}
          />
        }
      />

      
    </>
  );
};

export default NumberFilter;
